module.exports = __webpack_public_path__ + "static/media/key-blue.eb472c21.svg";